const styleSheet = (theme: any) => ({
  wrapper: {
    width: "100%",
    height: "100%",
    backgroundColor: "#fff"
  },
  sideBar: {
    backgroundColor: "#fff",
    width: "100%"
  },
  sideBarIsOpen: {
    transition: "all 300ms"
  },
  sideBarIsClosed: {
    transition: "all 300ms"
  },

  cursor: {
    cursor: "pointer"
  },
  primaryOpenClose: {
    display: "flex",
    justifyContent: "center",
    padding: 10
  },
  secondaryCloseContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingTop: 10,
    paddingRight: 12,
    paddingBottom: 10,
    paddingLeft: 10
  },
  secondaryCloseButtonTransition: {
    transition: "visibility 0s linear 100ms, opacity 100ms"
  },
  secondaryCloseButtonOpen: {
    visibility: "visible",
    opacity: 1
  },
  secondaryCloseButtonClose: {
    visibility: "hidden",
    opacity: 0
  },
  sideBarIsOpenDisplay: {
    display: "block"
  },
  sideBarIsClosedDisplay: {
    display: "none"
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/SideBar/SideBarContent/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/components/SideBar/SideBarContent/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }